import axios from "axios";
import Config from "../../config/";
const API_KEY = Config.apikey;
const ROOT_URL = Config.rooturl;

export function cekAuth() {
  return {
    headers: { Authorization: API_KEY + localStorage.getItem("token")}
  };
}

export function fetchDataTable() {
  const url = `${ROOT_URL}datasetsglob/datasetsglob/`;

  const fdata = new FormData();
  fdata.append("limit", 10);

  const request = axios.get(url, fdata, cekAuth(), {
    onUploadProgress: progressEvent => {
      console.log(progressEvent.loaded / progressEvent.total);
    }
  });

  return request;
}

export function pushUpdateStars(stars, datanya)
{
  console.log(datanya);
  const url = `${ROOT_URL}datasets/datasets/${datanya[0]}/`;

  const fdata = new FormData();
  fdata.append("author", datanya[1]);
  fdata.append("dataseturl", datanya[8]);
  fdata.append("date_created", datanya[7]);
  fdata.append("price", datanya[4]);
  fdata.append("stars", stars);
  fdata.append("user_id", datanya[6]);

  const request = axios.put(url, fdata, cekAuth(), {
    onUploadProgress: progressEvent => {
      console.log(progressEvent.loaded / progressEvent.total);
    }
  });

  return request;
}

export function pushUpdateStarsGlob(stars, datanya) {
  console.log(datanya);
  const url = `${ROOT_URL}datasetsglob/datasetsglob/${datanya[0]}/`;

  const fdata = new FormData();
  fdata.append("author", datanya[1]);
  fdata.append("dataseturl", datanya[8]);
  fdata.append("date_created", datanya[7]);
  fdata.append("price", datanya[4]);
  fdata.append("stars", stars);
  fdata.append("user_id", datanya[6]);

  const request = axios.put(url, fdata, cekAuth(), {
    onUploadProgress: progressEvent => {
      console.log(progressEvent.loaded / progressEvent.total);
    }
  });

  return request;
}

export function pushAddFav(data) {
  console.log(data);
  const url = `${ROOT_URL}datafav/datafavapi/${data}/`;

  const fdata = new FormData();
  fdata.append("datasetsglob_id", data);
  fdata.append("user_id", localStorage.getItem("id"));

  const request = axios.post(url, fdata, cekAuth(), {
    onUploadProgress: progressEvent => {
      console.log(progressEvent.loaded / progressEvent.total);
    }
  });

  return request;
}

export function deleteFav(data) {
  console.log(data);
  const url = `${ROOT_URL}datafav/datafavdelete/${data}/`;
  const request = axios.delete(url, cekAuth());

  return request;
}
